export default __webpack_public_path__ + "static/media/object-3.d08bdca6.webp";